<template>
  <div class="creek-shows-page">
    <creek-shows :weekday="weekdayNumber" :page-selected="pageSelected"></creek-shows>
  </div>
</template>

<script type="text/javascript">

import mixins from '../util/mixins';
import lang from '../lang/eng';
import fecha from 'fecha';
import JSONP from 'jsonp';

import CreekShows from './Shows';

export default {

  name: 'creek-page-shows',

  props: ['page-selected'],

  mixins: [mixins.routes],
  
  components: {
    'creek-shows': CreekShows,
  },

  data () {

    return {

      // TODO: GET FROM CREEK MAIN
      showsByWeekday: null,

      showsNavText: lang.schedule

    }

  },

  computed: {
    weekdayNumber (){
      if(typeof pageSelected != "undefined" && pageSelected){
        return pageSelected;
      }
      else if (typeof this.$route.params.weekdayNumber != 'undefined') {
        return this.$route.params.weekdayNumber;
      }
      else{
        return this.getWeekdayNumberForToday()
      }
    },
    showsForSelectedWeekday () {
      if (!this.showsByWeekday) {
        return [];
      }
      else if(this.weekdayNumber) {
        return this.showsByWeekday[this.weekdayNumber].programs;
      }
    }
  },
  methods: {

    fetchData () {
      
      var URL = this.Creek.config.content.baseURLForAPI + "/api/schedule";

      //Only get data if it doens't already exist
      if (this.showsByWeekday == null) {
        
        this.Creek.debug.log("Loading Vue.js route: show schedule");
        
        var _this = this;
        
        JSONP(URL, null, function (err, data) {
          if(err){
            this.Creek.debug.log(err);
          }
          _this.showsByWeekday = data;
        });

      }

      // this.setTitle(this.Creek.util.capitalizeFirstLetter(this.Creek.config.shows.showsName));
      // this.swapPageClass("shows");

    },

    getWeekdayNumberForToday() {

      var weekdayNumber = parseInt(fecha.format(new Date(), 'd'));

      if(weekdayNumber === 0){
        weekdayNumber = 7;
      }

      return weekdayNumber;

    }

  },
  created () {
    this.fetchData();
  },
}

</script>
